import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the AnalyticsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kitchen-avg-time-complete-order',
  templateUrl: 'kitchen-avg-time-complete-order.html',
})
export class KitchenAvgTimeCompleteOrderPage {

  public chartData: any;
  public chartLabels: any;
  public chartCheck: any;
  avg_duration_table: any;
  avg_duration_tk: any;
  //datatable
  rows = [];
  temp = [];
  rows2 = [];
  temp2 = [];
  columns = [
    { prop: 'DATE', name: this.translate.instant('general-fecha') },
    { prop: 'USER_NAME', name: this.translate.instant('general-cocinero') },
    { prop: 'TOTAL_ELEMENTS', name: this.translate.instant('home-dashboard-last-sales-num-elementos') },
    { prop: 'TIME_TOTAL', name: this.translate.instant('general-duracion') + ' (minutos)' },
    { prop: 'TIME_TO_SEE', name: 'En empezar' + ' (minutos)' },
    { prop: 'TIME_TO_COOK', name: 'En cocinar' + ' (minutos)' },
    { prop: 'TYPE', name: this.translate.instant('general-tipo') },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController
  ) {
    this.getAnalyticsData();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/kitchen_avg_time_complete_order', params, {})
      .subscribe(async response => {
        //total
        this.avg_duration_table = response['avg_duration_table'].toFixed(2);
        this.avg_duration_tk = response['avg_duration_tk'].toFixed(2);

        this.chartLabels = response['data_kitchen']['labels'];//Dates

        this.chartData = {
          labels: this.chartLabels,
          datasets: response['data_kitchen']['data']
        };

        //traducir los tipos de pedidos
        var response_array = response['list'];
        for (let i = 0; i < response_array.length; i++) {
          if (response_array[i].TYPE == 'takeaway') {
            response_array[i].TYPE = this.translate.instant('general-takeaway');
          } else {
            response_array[i].TYPE = this.translate.instant('general-mesa');
          }
        }

        //listado
        this.rows = response_array;
        this.temp = response_array;
        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  updateFilter2(event) {
    const val2 = event.target.value.toLowerCase();

    // filter our data
    const temp2 = this.temp2.filter(function (d) {
      return d.date.toLowerCase().indexOf(val2) !== -1 || !val2;
    });

    // update the rows
    this.rows2 = temp2;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const formatedData = this.rows.map(x => ({
      'date': x.DATE,
      'chef': x.USER_NAME,
      'nº elements': x.TOTAL_ELEMENTS,
      'duration': x.TIME_TOTAL,
      'duration to start': x.TIME_TO_SEE,
      'duration to cook': x.TIME_TO_COOK,
      'type': x.TYPE
    }));
    const params = new HttpParams()
      .set('data', JSON.stringify(formatedData))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({ 'Time Avg Tables': this.avg_duration_table, 'Time Avg Takeaway': this.avg_duration_tk }));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/kitchen-avg-time-complete-order/kitchen-avg-time-complete-order.ts